/**
 * @fileoverview DMQ (Data Management Query) dialog component for data analysis tools.
 * Provides a popup interface for accessing DMQ tools and performing data queries
 * on order information with configurable rules and parameters.
 *
 * @author Web Analysis Team
 * @version 1.0.0
 */

import React, { useEffect, useState } from 'react';
import RuleEditPopup from '../../../../csv-merge/components/RuleEditPopup';
import { loadResourceCSV } from '../../../../../utils/common';
import LoadingButton from '../../../../../components/controls/LoadingButton';
import { IData } from '../../../../../types';

/** Props for {@link DMQPopup}. */
interface DMQProps {
    /** Vendor configuration object. */
    vendor: any;
    /** Data provider for API calls. */
    dataProvider: any;
    /** Data containing order information. */
    data: IData;
}

/**
 * DMQ popup component for data management and query operations.
 * @param props - See {@link DMQProps}.
 */
const DMQPopup: React.FC<DMQProps> = ({ vendor, dataProvider, data }) => {
    const { order } = data;
    const [isOpen, setOpen] = useState(false);
    const [rule, setRule] = useState<any>();
    const [source, setSource] = useState<any>();

    useEffect(() => {
        loadResourceCSV(dataProvider, (response) => setSource(response));
    }, []);

    async function getData () {
        let response = await dataProvider.postData(vendor.controller, 'GetDMQTool', order);
        if (response && response.data) {
            let respOrder = response.data.order;
            setOpen(true);
            setRule({
                sources: source.filter((x: any) => respOrder.listing_accounts?.some(y => y === x.Id || y === x.Name)).map((x: any) => x.Name),
                event: respOrder.event,
                venue: respOrder.listing !== null ? respOrder.listing.venue : respOrder.venue,
                quantity: respOrder.listing !== null ? respOrder.listing.quantity : respOrder.quantity,
                tags: [''],
                priority: 1,
                expiredDate: respOrder.date,
                action: {
                    method: 'modify',
                    rules:
                        [{
                            id: 'Quantity',
                            field: 'Quantity',
                            type: 'string',
                            input: 'text',
                            operator: 'assign',
                            value: '=x-2'
                        }]
                }
            });
        }
    }

    return (
        <>
            <LoadingButton
                size="small"
                text=""
                variant="outlined"
                onClick={getData}
            >
                DMQ
            </LoadingButton>
            {isOpen && rule &&
                <RuleEditPopup dataProvider={dataProvider}
                    onClose={() => setOpen(false)}
                    // reloadPage={}
                    data={{
                        dlgName: 'dmq_isOpen',
                        isOpenRule: isOpen,
                        sources: source,
                        ruleId: [-1, rule]
                    }} />
            }
        </>
    );
};

export default React.memo(DMQPopup);
